import { CheckCircle2, MinusCircle, AlertTriangle, XCircle, TrendingUp } from "lucide-react";

const STYLES = {
  "Strong Buy": {
    cls: "bg-emerald-100 text-emerald-800 border-emerald-200",
    Icon: TrendingUp,
  },
  Buy: {
    cls: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Icon: CheckCircle2,
  },
  Hold: {
    cls: "bg-amber-50 text-amber-800 border-amber-200",
    Icon: MinusCircle,
  },
  Risky: {
    cls: "bg-orange-50 text-orange-800 border-orange-200",
    Icon: AlertTriangle,
  },
  Reject: {
    cls: "bg-red-50 text-red-700 border-red-200",
    Icon: XCircle,
  },
};

export default function VerdictBadge({ verdict, size = "sm", showIcon = true }) {
  const cfg = STYLES[verdict] || STYLES.Hold;
  const padding = size === "lg" ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs";
  return (
    <span
      data-testid={`verdict-${(verdict || "unknown").replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold tracking-wide ${cfg.cls} ${padding}`}
    >
      {showIcon && <cfg.Icon className="h-3.5 w-3.5" />}
      {verdict || "—"}
    </span>
  );
}
